<h3>Role Information</h3>

<section>
  <mat-form-field appearance="fill">
    <mat-label>Role</mat-label>
    <mat-select (selectionChange)="getSelectedRole()" [(value)]="guestRole.roleId" name="roleId" [(ngModel)]='guestRole.roleId' [disabled]="edit" required>
      @for (role of roles; track role) {
        <mat-option [value]="role.roleId">
          {{role.description}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Organization</mat-label>
    <input matInput [(ngModel)]="guestRole.organization" name="organization" [disabled]="edit" required />
  </mat-form-field>
</section>
<section>
  <mat-form-field appearance="fill">
    <mat-label>Start Date</mat-label>
    <input  matInput [matDatepicker]="startDatePicker" name="startDate"
      [(ngModel)]="guestRole.startDate"  [min]="currentDate" disabled required >
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker" [disabled]="!guestRole.roleId"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker [disabled]="!guestRole.roleId"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>End Date</mat-label>
      <input  matInput [matDatepicker]="endDatePicker" name="endDate"
        [(ngModel)]="guestRole.endDate" [min]="guestRole.startDate" [max]="maxEndDate" disabled required>
        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker" [disabled]="!guestRole.startDate"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker [disabled]="!guestRole.startDate"></mat-datepicker>
      </mat-form-field>
    </section>
    @if (guestRole.roleId && selectedRole) {
      <div id="month-limit-description">The {{selectedRole.description}} role has a limit of {{selectedRole.monthLimit}} month(s) from the current date.</div>
    }

    <section class="no-margin">
      <span class="check-box">
        <mat-checkbox name="expirationNotification"
        [(ngModel)]="guestRole.expirationNotification" color="primary"></mat-checkbox>
        <label>Send email notification a week before the role expires</label>
      </span>
    </section>
    @if (selectedRole && selectedRole.isActiveDirectoryRole) {
      <section class="no-margin">
        <span class="check-box">
          <mat-checkbox name="activeDirectoryAccount" [(ngModel)]="guestRole.activeDirectoryAccount" color="primary"></mat-checkbox>
          <label>Give user access to BYU-I network</label>
          @if (isNetworkAccountSetup === true) {
            <mat-icon matTooltip="BYU-I network access successfully setup">check_circle</mat-icon>
          }
          @if (isNetworkAccountSetup === false && isSending !== true) {
            <mat-icon matTooltip="Re-send account setup email"
            (click)="resendAccountSetupEmail()" [ngClass]="{'resend-button-disabled': isSending === false, 'resend-button': isSending !== false}">restart_alt</mat-icon>
          }
          @if (isNetworkAccountSetup === false && isSending === true) {
            <app-loading [inline]="true" size="sm" class="spinner"></app-loading>
          }
        </span>
      </section>
    }
